<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Descuento' : 'Crear Nuevo Descuento' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <form [formGroup]="discountForm" (ngSubmit)="onSubmit()">

        <!-- Nombre -->
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre del Descuento</mat-label>
            <input matInput formControlName="name" placeholder="Ej: Descuento Global Q35" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="nameControl?.invalid && (nameControl?.dirty || nameControl?.touched)">
                El nombre es requerido.
            </mat-error>
        </mat-form-field>

        <!-- Tipo de Asignación -->
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Tipo de Agrupación</mat-label>
            <mat-select formControlName="assignmentType">
                <mat-option *ngFor="let type of assignmentTypes" [value]="type.value">{{ type.label }}</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Monto base -->
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Monto Base (Q)</mat-label>
            <input matInput formControlName="defaultAmount" type="number" step="any" placeholder="Ej: 35.00" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="defaultAmountControl?.invalid && (defaultAmountControl?.dirty || defaultAmountControl?.touched)">
                <span *ngIf="defaultAmountControl?.errors?.['required']">El monto es requerido.</span>
                <span *ngIf="defaultAmountControl?.errors?.['min']">El monto no puede ser negativo.</span>
            </mat-error>
        </mat-form-field>

        <!-- Toggles -->
        <div class="flex flex-col mb-4 gap-2">
            <mat-slide-toggle [checked]="calculationStrategyControl?.value === 'PER_UNIT_PER_DAY'" (change)="onCalculationStrategyToggle($event.checked)" class="mb-4">
                ¿Aplicar monto por día?
            </mat-slide-toggle>
            <mat-slide-toggle formControlName="status" class="mb-4">
                ¿Descuento activo?
            </mat-slide-toggle>
        </div>

        <!-- Criterios de asignación -->
        <div [formGroup]="assignedCriteriaControl!" class="mb-4 p-4 border border-gray-600 rounded-md">

            <!-- GLOBAL: excepciones por bus opcionales -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'GLOBAL'">
                <h3 class="text-white text-md font-semibold mb-1">Excepciones por bus (opcional)</h3>
                <p class="text-gray-500 text-sm mb-3">El monto base aplica a todos los buses. Agrega excepciones para buses con un monto diferente.</p>

                <div *ngIf="busIdsFormArray?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    Sin excepciones — el monto base aplica a todos los buses.
                </div>

                <div formArrayName="busIds" class="flex flex-col gap-2 mb-3">
                    <div *ngFor="let busGroup of busIdsFormArray?.controls; let i = index" [formGroupName]="i" class="flex items-center gap-2 border border-gray-700 rounded p-3">
                        <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                        <div class="flex items-center gap-1">
                            <span class="text-gray-400 text-xs">Q</span>
                            <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                        </div>
                        <button matIconButton color="warn" type="button" (click)="removeBus(busGroup.controls.id.value)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>

                <mat-form-field floatLabel="always" class="w-full border-0">
                    <mat-label class="text-gray text-lg">Agregar excepción de bus</mat-label>
                    <input #busInputRef matInput [matAutocomplete]="autoBusGlobal" [formControl]="busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoBusGlobal="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="selectedBus($event)">
                        <mat-option *ngFor="let bus of filteredBuses$ | async" [value]="bus">{{ displayBusName(bus) }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- PARTNER -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'PARTNER'">
                <h3 class="text-white text-md font-semibold mb-3">Clientes</h3>

                <div *ngIf="partnerIdsFormArray?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido clientes.
                </div>

                <mat-accordion [multi]="true" class="mb-3" formArrayName="partnerIds">
                    <mat-expansion-panel *ngFor="let partnerGroup of partnerIdsFormArray?.controls; let i = index" [formGroupName]="i" class="mb-2 auto-height-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="w-full">
                                <div class="flex items-center w-full gap-2 py-1 pr-1">
                                    <span class="text-white text-sm flex-1">{{ getChipDisplayForPartner(partnerGroup.controls.id.value) }}</span>
                                    <div class="flex items-center gap-1 shrink-0" (click)="$event.stopPropagation()">
                                        <span class="text-gray-400 text-xs">Q</span>
                                        <input type="number"
                                               [value]="partnerGroup.controls.amount.value ?? ''"
                                               (change)="updateEntryAmount(partnerGroup, $any($event.target).value)"
                                               [min]="0"
                                               class="compact-amount-input">
                                    </div>
                                    <button matIconButton color="warn" (click)="removePartner(partnerGroup.controls.id.value); $event.stopPropagation()" type="button" class="shrink-0">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="pt-2">
                            <p class="text-gray-400 text-sm mb-2">Excepciones por bus (opcional)</p>

                            <div *ngIf="partnerGroup.controls.buses.length === 0" class="text-gray-600 text-sm italic mb-2">
                                Sin excepciones — aplica a todos los buses de este cliente.
                            </div>

                            <div formArrayName="buses" class="flex flex-col gap-2 mb-3">
                                <div *ngFor="let busGroup of partnerGroup.controls.buses.controls; let j = index" [formGroupName]="j" class="flex items-center gap-2 border border-gray-700 rounded p-2">
                                    <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                                    <div class="flex items-center gap-1">
                                        <span class="text-gray-400 text-xs">Q</span>
                                        <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                                    </div>
                                    <button matIconButton color="warn" type="button" (click)="removeBusFromEntry(partnerGroup, j)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <mat-form-field floatLabel="always" class="w-full border-0">
                                <mat-label class="text-gray text-lg">Añadir excepción de bus</mat-label>
                                <input matInput [matAutocomplete]="autoBusPartner" [formControl]="partnerGroup.controls.busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                                <mat-autocomplete #autoBusPartner="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="addBusToEntry($event, partnerGroup)">
                                    <mat-option *ngFor="let bus of getFilteredBusesForEntry(partnerGroup, 'partner') | async" [value]="bus">
                                        {{ displayBusName(bus) }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                    <mat-label class="text-gray text-lg">Buscar y Añadir Cliente</mat-label>
                    <input #partnerInputRef matInput [matAutocomplete]="autoPartner" [formControl]="partnerSearchControl" placeholder="Buscar cliente..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoPartner="matAutocomplete" (optionSelected)="selectedPartner($event)" [displayWith]="displayPartnerName">
                        <mat-option *ngFor="let partner of filteredPartners$ | async" [value]="partner">{{ partner.displayName || partner.email }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- ENTITY -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'ENTITY'">
                <h3 class="text-white text-md font-semibold mb-3">Entidades</h3>

                <div *ngIf="entityIdsFormArray?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido entidades.
                </div>

                <mat-accordion [multi]="true" class="mb-3" formArrayName="entityIds">
                    <mat-expansion-panel *ngFor="let entityGroup of entityIdsFormArray?.controls; let i = index" [formGroupName]="i" class="mb-2 auto-height-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="w-full">
                                <div class="flex items-center w-full gap-2 py-1 pr-1">
                                    <span class="text-white text-sm flex-1">{{ getChipDisplayForEntity(entityGroup.controls.id.value) }}</span>
                                    <div class="flex items-center gap-1 shrink-0" (click)="$event.stopPropagation()">
                                        <span class="text-gray-400 text-xs">Q</span>
                                        <input type="number"
                                               [value]="entityGroup.controls.amount.value ?? ''"
                                               (change)="updateEntryAmount(entityGroup, $any($event.target).value)"
                                               [min]="0"
                                               class="compact-amount-input">
                                    </div>
                                    <button matIconButton color="warn" (click)="removeEntity(entityGroup.controls.id.value); $event.stopPropagation()" type="button" class="shrink-0">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="pt-2">
                            <p class="text-gray-400 text-sm mb-2">Excepciones por bus (opcional)</p>

                            <div *ngIf="entityGroup.controls.buses.length === 0" class="text-gray-600 text-sm italic mb-2">
                                Sin excepciones — aplica a todos los buses de esta entidad.
                            </div>

                            <div formArrayName="buses" class="flex flex-col gap-2 mb-3">
                                <div *ngFor="let busGroup of entityGroup.controls.buses.controls; let j = index" [formGroupName]="j" class="flex items-center gap-2 border border-gray-700 rounded p-2">
                                    <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                                    <div class="flex items-center gap-1">
                                        <span class="text-gray-400 text-xs">Q</span>
                                        <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                                    </div>
                                    <button matIconButton color="warn" type="button" (click)="removeBusFromEntry(entityGroup, j)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <mat-form-field floatLabel="always" class="w-full border-0">
                                <mat-label class="text-gray text-lg">Añadir excepción de bus</mat-label>
                                <input matInput [matAutocomplete]="autoBusEntity" [formControl]="entityGroup.controls.busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                                <mat-autocomplete #autoBusEntity="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="addBusToEntry($event, entityGroup)">
                                    <mat-option *ngFor="let bus of getFilteredBusesForEntry(entityGroup, 'entity') | async" [value]="bus">
                                        {{ displayBusName(bus) }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                    <mat-label class="text-gray text-lg">Buscar y Añadir Entidad</mat-label>
                    <input #entityInputRef matInput [matAutocomplete]="autoEntity" [formControl]="entitySearchControl" placeholder="Buscar entidad..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoEntity="matAutocomplete" (optionSelected)="selectedEntity($event)" [displayWith]="displayEntityName">
                        <mat-option *ngFor="let entity of filteredEntities$ | async" [value]="entity">{{ entity.name }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- ROUTE -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'ROUTE'">
                <h3 class="text-white text-md font-semibold mb-3">Rutas</h3>

                <div *ngIf="routeIdsFormArray?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido rutas.
                </div>

                <mat-accordion [multi]="true" class="mb-3" formArrayName="routeIds">
                    <mat-expansion-panel *ngFor="let routeGroup of routeIdsFormArray?.controls; let i = index" [formGroupName]="i" class="mb-2 auto-height-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="w-full">
                                <div class="flex items-center w-full gap-2 py-1 pr-1">
                                    <span class="text-white text-sm flex-1">{{ getChipDisplayForRoute(routeGroup.controls.id.value) }}</span>
                                    <div class="flex items-center gap-1 shrink-0" (click)="$event.stopPropagation()">
                                        <span class="text-gray-400 text-xs">Q</span>
                                        <input type="number"
                                               [value]="routeGroup.controls.amount.value ?? ''"
                                               (change)="updateEntryAmount(routeGroup, $any($event.target).value)"
                                               [min]="0"
                                               class="compact-amount-input">
                                    </div>
                                    <button matIconButton color="warn" (click)="removeRoute(routeGroup.controls.id.value); $event.stopPropagation()" type="button" class="shrink-0">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="pt-2">
                            <p class="text-gray-400 text-sm mb-2">Excepciones por bus (opcional)</p>

                            <div *ngIf="routeGroup.controls.buses.length === 0" class="text-gray-600 text-sm italic mb-2">
                                Sin excepciones — aplica a todos los buses de esta ruta.
                            </div>

                            <div formArrayName="buses" class="flex flex-col gap-2 mb-3">
                                <div *ngFor="let busGroup of routeGroup.controls.buses.controls; let j = index" [formGroupName]="j" class="flex items-center gap-2 border border-gray-700 rounded p-2">
                                    <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                                    <div class="flex items-center gap-1">
                                        <span class="text-gray-400 text-xs">Q</span>
                                        <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                                    </div>
                                    <button matIconButton color="warn" type="button" (click)="removeBusFromEntry(routeGroup, j)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <mat-form-field floatLabel="always" class="w-full border-0">
                                <mat-label class="text-gray text-lg">Añadir excepción de bus</mat-label>
                                <input matInput [matAutocomplete]="autoBusRoute" [formControl]="routeGroup.controls.busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                                <mat-autocomplete #autoBusRoute="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="addBusToEntry($event, routeGroup)">
                                    <mat-option *ngFor="let bus of getFilteredBusesForEntry(routeGroup, 'route') | async" [value]="bus">
                                        {{ displayBusName(bus) }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                    <mat-label class="text-gray text-lg">Buscar y Añadir Ruta</mat-label>
                    <input #routeInputRef matInput [matAutocomplete]="autoRoute" [formControl]="routeSearchControl" placeholder="Buscar ruta..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoRoute="matAutocomplete" (optionSelected)="selectedRoute($event)" [displayWith]="displayRouteName">
                        <mat-option *ngFor="let route of filteredRoutes$ | async" [value]="route">{{ route.name }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- BUS -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'BUS'">
                <h3 class="text-white text-md font-semibold mb-3">Buses</h3>

                <div *ngIf="busIdsFormArray?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido buses.
                </div>

                <div formArrayName="busIds" class="flex flex-col gap-2 mb-3">
                    <div *ngFor="let busGroup of busIdsFormArray?.controls; let i = index" [formGroupName]="i" class="flex items-center gap-2 border border-gray-700 rounded p-3">
                        <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                        <div class="flex items-center gap-1">
                            <span class="text-gray-400 text-xs">Q</span>
                            <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                        </div>
                        <button matIconButton color="warn" type="button" (click)="removeBus(busGroup.controls.id.value)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>

                <mat-form-field floatLabel="always" class="w-full border-0">
                    <mat-label class="text-gray text-lg">Buscar y Añadir Bus</mat-label>
                    <input #busInputRef matInput [matAutocomplete]="autoBus" [formControl]="busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoBus="matAutocomplete" (optionSelected)="selectedBus($event)" [displayWith]="displayBusName">
                        <mat-option *ngFor="let bus of filteredBuses$ | async" [value]="bus">{{ bus.name }} ({{ bus.licensePlate }})</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- PARTNER_ENTITY -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'PARTNER_ENTITY'">
                <h3 class="text-white text-md font-semibold mb-3">Clientes y Entidades</h3>

                <div *ngIf="partnerEntityMapGroupsControl?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido clientes.
                </div>

                <mat-accordion [multi]="true" class="mb-3" formArrayName="partnerEntityMap">
                    <mat-expansion-panel *ngFor="let mapGroup of partnerEntityMapGroupsControl?.controls; let i = index" [formGroupName]="i" class="mb-2 auto-height-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="w-full">
                                <div class="flex items-center justify-between w-full py-1 pr-1 gap-2">
                                    <span class="text-white text-sm leading-snug flex-1">{{ getChipDisplayForPartner(mapGroup.controls.key.value) }}</span>
                                    <button matIconButton color="warn" (click)="removeMapKeyEntry(i, partnerEntityMapGroupsControl); $event.stopPropagation()" type="button" class="shrink-0">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div formArrayName="values" class="flex flex-col gap-2 mb-3 pt-2">
                            <div *ngIf="mapGroup.controls.values.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-2 text-sm">
                                No se han añadido entidades.
                            </div>

                            <mat-accordion [multi]="true">
                                <mat-expansion-panel *ngFor="let entityGroup of mapGroup.controls.values.controls; let j = index" [formGroupName]="j" class="mb-1 auto-height-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="w-full">
                                            <div class="flex items-center w-full gap-2 py-1 pr-1">
                                                <span class="text-white text-sm flex-1">{{ getChipDisplayForEntity(entityGroup.controls.id.value) }}</span>
                                                <div class="flex items-center gap-1 shrink-0" (click)="$event.stopPropagation()">
                                                    <span class="text-gray-400 text-xs">Q</span>
                                                    <input type="number"
                                                           [value]="entityGroup.controls.amount.value ?? ''"
                                                           (change)="updateEntryAmount(entityGroup, $any($event.target).value)"
                                                           [min]="0"
                                                           class="compact-amount-input">
                                                </div>
                                                <button matIconButton color="warn" (click)="removeValueFromMapEntry(entityGroup.controls.id.value, mapGroup); $event.stopPropagation()" type="button" class="shrink-0">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div class="pt-2">
                                        <p class="text-gray-400 text-sm mb-2">Excepciones por bus (opcional)</p>

                                        <div *ngIf="entityGroup.controls.buses.length === 0" class="text-gray-600 text-sm italic mb-2">
                                            Sin excepciones — aplica a todos los buses.
                                        </div>

                                        <div formArrayName="buses" class="flex flex-col gap-1 mb-3">
                                            <div *ngFor="let busGroup of entityGroup.controls.buses.controls; let k = index" [formGroupName]="k" class="flex items-center gap-2 border border-gray-700 rounded p-2">
                                                <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                                                <div class="flex items-center gap-1">
                                                    <span class="text-gray-400 text-xs">Q</span>
                                                    <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                                                </div>
                                                <button matIconButton color="warn" type="button" (click)="removeBusFromEntry(entityGroup, k)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <mat-form-field floatLabel="always" class="w-full border-0">
                                            <mat-label class="text-gray text-lg">Añadir excepción de bus</mat-label>
                                            <input matInput [matAutocomplete]="autoBusPE" [formControl]="entityGroup.controls.busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                                            <mat-autocomplete #autoBusPE="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="addBusToEntry($event, entityGroup)">
                                                <mat-option *ngFor="let bus of getFilteredBusesForMapEntry(entityGroup, mapGroup.controls.key.value, 'partner_entity') | async" [value]="bus">
                                                    {{ displayBusName(bus) }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                            <mat-label class="text-gray text-lg">Añadir Entidad</mat-label>
                            <input matInput [matAutocomplete]="autoEntityForPartner" [formControl]="mapGroup.controls.valueSearchControl" placeholder="Buscar entidad..." class="text-lg text-white bg-blue-primary">
                            <mat-autocomplete #autoEntityForPartner="matAutocomplete" (optionSelected)="selectValueForMapEntry($event, mapGroup)" [displayWith]="displayEntityName">
                                <mat-option *ngFor="let entity of filteredMapPartnerEntities$(mapGroup) | async" [value]="entity">{{ entity.name }}</mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                    <mat-label class="text-gray text-lg">Añadir Cliente</mat-label>
                    <input #mapPartnerKeyInputRef matInput [matAutocomplete]="autoMapPartnerKey" [formControl]="mapPartnerKeySearchControl" placeholder="Buscar cliente..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoMapPartnerKey="matAutocomplete" (optionSelected)="addMapKeyToPartnerEntity($event)" [displayWith]="displayPartnerName">
                        <mat-option *ngFor="let partner of filteredMapPartnerKeys$ | async" [value]="partner">{{ partner.displayName || partner.email }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- ROUTE_ENTITY -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'ROUTE_ENTITY'">
                <h3 class="text-white text-md font-semibold mb-3">Rutas y Entidades</h3>

                <div *ngIf="routeEntityMapGroupsControl?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido rutas.
                </div>

                <mat-accordion [multi]="true" class="mb-3" formArrayName="routeEntityMap">
                    <mat-expansion-panel *ngFor="let mapGroup of routeEntityMapGroupsControl?.controls; let i = index" [formGroupName]="i" class="mb-2 auto-height-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="w-full">
                                <div class="flex items-center justify-between w-full py-1 pr-1 gap-2">
                                    <span class="text-white text-sm leading-snug flex-1">{{ getChipDisplayForRoute(mapGroup.controls.key.value) }}</span>
                                    <button matIconButton color="warn" (click)="removeMapKeyEntry(i, routeEntityMapGroupsControl); $event.stopPropagation()" type="button" class="shrink-0">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div formArrayName="values" class="flex flex-col gap-2 mb-3 pt-2">
                            <div *ngIf="mapGroup.controls.values.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-2 text-sm">
                                No se han añadido entidades.
                            </div>

                            <mat-accordion [multi]="true">
                                <mat-expansion-panel *ngFor="let entityGroup of mapGroup.controls.values.controls; let j = index" [formGroupName]="j" class="mb-1 auto-height-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="w-full">
                                            <div class="flex items-center w-full gap-2 py-1 pr-1">
                                                <span class="text-white text-sm flex-1">{{ getChipDisplayForEntity(entityGroup.controls.id.value) }}</span>
                                                <div class="flex items-center gap-1 shrink-0" (click)="$event.stopPropagation()">
                                                    <span class="text-gray-400 text-xs">Q</span>
                                                    <input type="number"
                                                           [value]="entityGroup.controls.amount.value ?? ''"
                                                           (change)="updateEntryAmount(entityGroup, $any($event.target).value)"
                                                           [min]="0"
                                                           class="compact-amount-input">
                                                </div>
                                                <button matIconButton color="warn" (click)="removeValueFromMapEntry(entityGroup.controls.id.value, mapGroup); $event.stopPropagation()" type="button" class="shrink-0">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div class="pt-2">
                                        <p class="text-gray-400 text-sm mb-2">Excepciones por bus (opcional)</p>

                                        <div *ngIf="entityGroup.controls.buses.length === 0" class="text-gray-600 text-sm italic mb-2">
                                            Sin excepciones — aplica a todos los buses.
                                        </div>

                                        <div formArrayName="buses" class="flex flex-col gap-1 mb-3">
                                            <div *ngFor="let busGroup of entityGroup.controls.buses.controls; let k = index" [formGroupName]="k" class="flex items-center gap-2 border border-gray-700 rounded p-2">
                                                <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                                                <div class="flex items-center gap-1">
                                                    <span class="text-gray-400 text-xs">Q</span>
                                                    <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                                                </div>
                                                <button matIconButton color="warn" type="button" (click)="removeBusFromEntry(entityGroup, k)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <mat-form-field floatLabel="always" class="w-full border-0">
                                            <mat-label class="text-gray text-lg">Añadir excepción de bus</mat-label>
                                            <input matInput [matAutocomplete]="autoBusRE" [formControl]="entityGroup.controls.busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                                            <mat-autocomplete #autoBusRE="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="addBusToEntry($event, entityGroup)">
                                                <mat-option *ngFor="let bus of getFilteredBusesForMapEntry(entityGroup, mapGroup.controls.key.value, 'route_entity') | async" [value]="bus">
                                                    {{ displayBusName(bus) }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                            <mat-label class="text-gray text-lg">Añadir Entidad</mat-label>
                            <input matInput [matAutocomplete]="autoEntityForRoute" [formControl]="mapGroup.controls.valueSearchControl" placeholder="Buscar entidad..." class="text-lg text-white bg-blue-primary">
                            <mat-autocomplete #autoEntityForRoute="matAutocomplete" (optionSelected)="selectValueForMapEntry($event, mapGroup)" [displayWith]="displayEntityName">
                                <mat-option *ngFor="let entity of filteredMapRouteEntities$(mapGroup) | async" [value]="entity">{{ entity.name }}</mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                    <mat-label class="text-gray text-lg">Añadir Ruta</mat-label>
                    <input #mapRouteKeyInputRef matInput [matAutocomplete]="autoMapRouteKey" [formControl]="mapRouteKeySearchControl" placeholder="Buscar ruta..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoMapRouteKey="matAutocomplete" (optionSelected)="addMapKeyToRouteEntity($event)" [displayWith]="displayRouteName">
                        <mat-option *ngFor="let route of filteredMapRouteKeys$ | async" [value]="route">{{ route.name }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- PARTNER_ROUTE -->
            <ng-container *ngIf="assignmentTypeControl?.value === 'PARTNER_ROUTE'">
                <h3 class="text-white text-md font-semibold mb-3">Clientes y Rutas</h3>

                <div *ngIf="partnerRouteMapGroupsControl?.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-3 mb-3">
                    No se han añadido clientes.
                </div>

                <mat-accordion [multi]="true" class="mb-3" formArrayName="partnerRouteMap">
                    <mat-expansion-panel *ngFor="let mapGroup of partnerRouteMapGroupsControl?.controls; let i = index" [formGroupName]="i" class="mb-2 auto-height-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="w-full">
                                <div class="flex items-center justify-between w-full py-1 pr-1 gap-2">
                                    <span class="text-white text-sm leading-snug flex-1">{{ getChipDisplayForPartner(mapGroup.controls.key.value) }}</span>
                                    <button matIconButton color="warn" (click)="removeMapKeyEntry(i, partnerRouteMapGroupsControl); $event.stopPropagation()" type="button" class="shrink-0">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div formArrayName="values" class="flex flex-col gap-2 mb-3 pt-2">
                            <div *ngIf="mapGroup.controls.values.length === 0" class="text-gray-500 text-center border border-gray-700 rounded p-2 text-sm">
                                No se han añadido rutas.
                            </div>

                            <mat-accordion [multi]="true">
                                <mat-expansion-panel *ngFor="let routeGroup of mapGroup.controls.values.controls; let j = index" [formGroupName]="j" class="mb-1 auto-height-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="w-full">
                                            <div class="flex items-center w-full gap-2 py-1 pr-1">
                                                <span class="text-white text-sm flex-1">{{ getChipDisplayForRoute(routeGroup.controls.id.value) }}</span>
                                                <div class="flex items-center gap-1 shrink-0" (click)="$event.stopPropagation()">
                                                    <span class="text-gray-400 text-xs">Q</span>
                                                    <input type="number"
                                                           [value]="routeGroup.controls.amount.value ?? ''"
                                                           (change)="updateEntryAmount(routeGroup, $any($event.target).value)"
                                                           [min]="0"
                                                           class="compact-amount-input">
                                                </div>
                                                <button matIconButton color="warn" (click)="removeValueFromMapEntry(routeGroup.controls.id.value, mapGroup); $event.stopPropagation()" type="button" class="shrink-0">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div class="pt-2">
                                        <p class="text-gray-400 text-sm mb-2">Excepciones por bus (opcional)</p>

                                        <div *ngIf="routeGroup.controls.buses.length === 0" class="text-gray-600 text-sm italic mb-2">
                                            Sin excepciones — aplica a todos los buses.
                                        </div>

                                        <div formArrayName="buses" class="flex flex-col gap-1 mb-3">
                                            <div *ngFor="let busGroup of routeGroup.controls.buses.controls; let k = index" [formGroupName]="k" class="flex items-center gap-2 border border-gray-700 rounded p-2">
                                                <span class="text-white flex-grow text-sm">{{ getChipDisplayForBus(busGroup.controls.id.value) }}</span>
                                                <div class="flex items-center gap-1">
                                                    <span class="text-gray-400 text-xs">Q</span>
                                                    <input type="number" formControlName="amount" [min]="0" class="compact-amount-input">
                                                </div>
                                                <button matIconButton color="warn" type="button" (click)="removeBusFromEntry(routeGroup, k)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <mat-form-field floatLabel="always" class="w-full border-0">
                                            <mat-label class="text-gray text-lg">Añadir excepción de bus</mat-label>
                                            <input matInput [matAutocomplete]="autoBusPR" [formControl]="routeGroup.controls.busSearchControl" placeholder="Buscar bus..." class="text-lg text-white bg-blue-primary">
                                            <mat-autocomplete #autoBusPR="matAutocomplete" [displayWith]="displayBusName" (optionSelected)="addBusToEntry($event, routeGroup)">
                                                <mat-option *ngFor="let bus of getFilteredBusesForMapEntry(routeGroup, mapGroup.controls.key.value, 'partner_route') | async" [value]="bus">
                                                    {{ displayBusName(bus) }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                            <mat-label class="text-gray text-lg">Añadir Ruta</mat-label>
                            <input matInput [matAutocomplete]="autoRouteForPartner" [formControl]="mapGroup.controls.valueSearchControl" placeholder="Buscar ruta..." class="text-lg text-white bg-blue-primary">
                            <mat-autocomplete #autoRouteForPartner="matAutocomplete" (optionSelected)="selectValueForMapEntry($event, mapGroup)" [displayWith]="displayRouteName">
                                <mat-option *ngFor="let route of filteredMapPartnerRoutes$(mapGroup) | async" [value]="route">{{ route.name }}</mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-form-field floatLabel="always" class="w-full border-0 mt-3">
                    <mat-label class="text-gray text-lg">Añadir Cliente</mat-label>
                    <input #mapPartnerKeyInputRef matInput [matAutocomplete]="autoMapPartnerKeyPR" [formControl]="mapPartnerKeySearchControl" placeholder="Buscar cliente..." class="text-lg text-white bg-blue-primary">
                    <mat-autocomplete #autoMapPartnerKeyPR="matAutocomplete" (optionSelected)="addMapKeyToPartnerRoute($event)" [displayWith]="displayPartnerName">
                        <mat-option *ngFor="let partner of filteredMapPartnerKeys$ | async" [value]="partner">{{ partner.displayName || partner.email }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

        </div>

        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>

    </form>
</mat-dialog-content>
